$(document).ready(function() {
    let cookieConsent = document.getElementsByClassName("CookieConsent")[0];
    let acceptBtn = document.getElementsByClassName("ConsentButton")[0];
    let closeBtn = document.getElementsByClassName("ConsentCloseButton")[0];

    if(cookieConsent) {
        cookieConsent.classList.remove("hidden");
        setTimeout(()=>cookieConsent.classList.add("fade-in"));
    
        acceptBtn.onclick = function () {
            cookieConsent.classList.remove("fade-in");
            setTimeout(()=>cookieConsent.classList.add("hidden"), 300);
        };
        closeBtn.onclick = function () {
            cookieConsent.classList.remove("fade-in");
            setTimeout(()=>cookieConsent.classList.add("hidden"), 300);
        };
    }
});
